export const RESET_APP = "RESET_APP";
export const RENDER_WEBSITE_PAGE = "RENDER_WEBSITE_PAGE";
export const SET_WEBSITE_MENUS = "SET_WEBSITE_MENUS";